import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, COMMAND_PRIORITY_LOW, PASTE_COMMAND } from 'lexical';
import { useEffect } from 'react';

import {
  $createCitationNode,
  containsSerializedCitationNode,
} from '../CitationPlugin/CitationNode';
import { splitTextByCitationTokens } from '../CitationPlugin/citationTokens';

export function $handleCitationPaste(event: ClipboardEvent): boolean {
  const clipboardData = event.clipboardData;
  if (!clipboardData) return false;

  // Citation-aware rich copy serializes citation nodes into the HTML flavor.
  // Let Lexical's normal rich-text paste import that HTML so formatting and
  // citation positions are both preserved.
  const html = clipboardData.getData('text/html');
  if (containsSerializedCitationNode(html)) return false;

  const text = clipboardData.getData('text/plain');
  const segments = splitTextByCitationTokens(text);
  const hasCitations = segments.some((segment) => segment.type === 'citation');
  if (!hasCitations) return false;

  const selection = $getSelection();
  if (!selection) return false;

  for (const segment of segments) {
    if (segment.type === 'text') {
      selection.insertText(segment.text);
    } else {
      selection.insertNodes([$createCitationNode(segment.paragraphIds)]);
    }
  }

  event.preventDefault();
  return true;
}

export function CitationPastePlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      $handleCitationPaste,
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
}
